import { app } from './app'
import { RemoteConfig, getRemoteConfig, isSupported } from 'firebase/remote-config'

export const remoteConfig = async () => ((await isSupported()) && getRemoteConfig(app)) as RemoteConfig
